import { sanitizeHTML } from "@/lib/utils";
import Link from "next/link";

interface SecExpectData {
  heading?: {
    text?: string;
    title?: string;
  };
  text?: {
    text?: string;
  };
  button?: {
    label?: string;
    href?: string;
  };
  content_collection?: {
    id: string;
    site_content_collections_id: {
      collection: {
        item: {
          title: string;
          text: string;
        };
      }[];
    };
  }[];
}

export const fields = [
  "heading.text",
  "heading.title",
  "text.text",
  "content_collection.id",
  "content_collection.site_content_collections_id.collection.item:site_content.title",
  "content_collection.site_content_collections_id.collection.item:site_content.text",
  "button.label",
  "button.href",
] as const;

interface SecExpectProps {
  data?: SecExpectData;
}

export default function SecExpect({ data }: SecExpectProps) {
  return (
		<>
			<section
					id='procedures'
					className='SecProcedures relative bg-[#e4e3e3] py-16 overflow-hidden'
				>
					<div className='container relative'>
						<div className='grid gap-8'>
							{/* Content Column - Full Width */}
							<div className='w-full'>
								{/* Header */}
								<div className='text-center mb-12'>
									<h2
										className='text-4xl md:text-5xl font-light font-freightBig leading-tight md:leading-[48px] mb-6'
										dangerouslySetInnerHTML={sanitizeHTML(
											data?.heading?.title || ''
										)}
									/>
									<div
										className='text-base font-light font-aileron max-w-4xl mx-auto'
										dangerouslySetInnerHTML={sanitizeHTML(
											data?.text?.text || ''
										)}
									/>
								</div>

								{/* All Cards in Single Grid */}
								<div className='flex flex-wrap gap-8 justify-center'>
									{(data?.content_collection || []).map((card, index) => {
										const titleItem =
											card.site_content_collections_id.collection.find(
												c => c.item.title
											)
										const textItem =
											card.site_content_collections_id.collection.find(
												c => c.item.text
											)

										return (
											<div
												key={card.id}
												className='w-full md:w-[45%] lg:w-[30%]'
											>
												<div className='bg-[#F4F4F4] rounded-lg p-8 h-full'>
													<div className='flex md:gap-6 max-md:flex-wrap max-md:justify-center'>
														<span className='text-3xl 3xl:text-4xl font-freightBig md:leading-[36px]'>
															{index + 1}
														</span>
														<div>
															<h3 className='max-md:text-center text-3xl md:text-4xl font-light font-freightBig leading-tight md:leading-[36px] text-[#332f2c]'>
																{titleItem?.item.title || ''}
															</h3>
															<div
																className='mt-5 text-base font-light font-aileron grid gap-4'
																dangerouslySetInnerHTML={sanitizeHTML(
																	textItem?.item.text || ''
																)}
															/>
														</div>
													</div>
												</div>
											</div>
										)
									})}
								</div>
							</div>
						</div>
						<div className='mt-12 flex justify-center'>
							<Link
								href={data?.button?.href || ''}
								className='bg-[#F4F4F4] rounded-[60px] px-[35px] py-[25px] font-serenity text-base font-semibold capitalize leading-tight tracking-wider text-[#332f2c]'
							>
								{data?.button?.label || ''}
							</Link>
						</div>
					</div>
				</section>
		</>
	)
}
